import { Provider } from "react-redux";
import { RouterProvider } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
// ALL PAGE ROUTES
import routes from "./routes";
// REDUX STORE
import { store } from "./redux/Store";
// FAKE DB
import "../fake-db";
import { HelmetProvider } from "react-helmet-async";
import ThemeProvider from "./components/ThemeProvider";
import "../i18n";
import LanguageBootstrap from "./components/LanguageBootstrap";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60 * 1000,
      gcTime: 5 * 60 * 1000,
      refetchOnWindowFocus: false,
    },
  },
});

export default function App() {
  return (
    <HelmetProvider>  
    <Provider store={store}>
      <QueryClientProvider client={queryClient}>
        <ThemeProvider>
          <LanguageBootstrap />
          <RouterProvider router={routes} />
          <ToastContainer />
        </ThemeProvider>
      </QueryClientProvider>
    </Provider>
    </HelmetProvider>   
  );
}
